module.exports = __webpack_public_path__ + "img/IS.dc313c31.png";